import { render, staticRenderFns } from "./listaReservas.vue?vue&type=template&id=16e98502&"
import script from "./listaReservas.vue?vue&type=script&lang=js&"
export * from "./listaReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports